import { DELIVERABLES_CRUD_ACTION_CREATORS } from '../actions/deliverables_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { nullSafeGet } from '../utils/DataAccessUtils';
import { ROLE_TYPES } from '../utils/DataConstants';

const fetchUtils = new FetchUtils();

// Real backend: /api/v1/{buyer|supplier}/project/project_deliverables
// (openwrench-app claude/project-deliverables-tasks). GET responses are hydrated
// with server-computed workOrderMetrics / taskMetrics / budgetUsed.
export const deliverablesRestCrudThunksForBuyer = new RestCrudThunks(
	'project_deliverables',
	'project_deliverable',
	'projectDeliverable',
	'projectDeliverables',
	DELIVERABLES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'project/'
);

export const deliverablesRestCrudThunksForSupplier = new RestCrudThunks(
	'project_deliverables',
	'project_deliverable',
	'projectDeliverable',
	'projectDeliverables',
	DELIVERABLES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'project/'
);

// Dedicated idempotent link/unlink endpoints (one work order at a time). The
// PATCH returns the updated, re-hydrated deliverable (workOrders + metrics), so
// we push it straight into the detail via fetchOneSuccess.
const linkWorkOrderThunk = (userType, link) => (deliverableId, workOrderId) => {
	const verb = link ? 'link_work_order' : 'unlink_work_order';
	const apiUrl = `/api/v1/${userType}/project/project_deliverables/${deliverableId}/${verb}/${workOrderId}`;
	return (dispatch) =>
		new Promise((resolve, reject) => {
			fetchUtils
				.patch(getBackendUri() + apiUrl, { data: {} })
				.then(parseJSON)
				.then(({ json, status }) => {
					if (status === 200) {
						dispatch(DELIVERABLES_CRUD_ACTION_CREATORS.fetchOneSuccess(json.data));
						resolve(json.data);
					} else {
						reject(nullSafeGet('message', json));
					}
				})
				.catch((error) => reject(error.message));
		});
};

export const linkDeliverableWorkOrderForBuyer = linkWorkOrderThunk(ROLE_TYPES.BUYER, true);
export const linkDeliverableWorkOrderForSupplier = linkWorkOrderThunk(ROLE_TYPES.SUPPLIER, true);
export const unlinkDeliverableWorkOrderForBuyer = linkWorkOrderThunk(ROLE_TYPES.BUYER, false);
export const unlinkDeliverableWorkOrderForSupplier = linkWorkOrderThunk(ROLE_TYPES.SUPPLIER, false);
